import React from 'react';
import { DialogTitle, DialogContent, DialogActions, Dialog, Button } from '@mui/material';
import useAppLanguage from '@/hooks/useAppLanguage';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns-tz';
import { DAY_DATE_FORMAT } from '@/helpers/constants';
import { CampaignDeactivated } from '@/types/Files';
import InputText from '../UI/InputText/InputText';
import styles from './DialogFiles.module.scss';

type DialogFilesProps = {
  close: () => void;
  data: CampaignDeactivated;
};

const DialogFiles: React.FC<DialogFilesProps> = (props) => {
  const { close, data } = props;
  const { t } = useTranslation();
  const lang = useAppLanguage();

  return (
    <Dialog
      open
      maxWidth="md"
      aria-labelledby="form-dialog-deactivated"
    >
      <DialogTitle id="form-dialog-status-title" data-testId="form-dialog-status-title"> {t('action.CLOSED')} </DialogTitle>
      <DialogContent>
        <div className={styles.DialogFiles}>
          <div className={styles.Message}>
            {t('attachments.deactivationErrorP1')} <span data-testId="dialog-files-cr-id">{data?.id}</span> {t('attachments.deactivationErrorP2')}
          </div>
          <div className={styles.Flex}>
            <div className={styles.TwoColumns}>
              <InputText
                disabled
                id="files-input-status-action-taken-by"
                label={t('dialog.statusActionTakenBy')}
                value={data?.user}
              />
            </div>
            <div className={styles.TwoColumns}>
              <InputText
                disabled
                id="files-input-status-created"
                label={t('dialog.statusTimestamp')}
                value={format(new Date(data?.timestamp), DAY_DATE_FORMAT)}
              />
            </div>
          </div>
          <div className={styles.OneColumns}>
            <InputText
              disabled
              id="files-input-status-comments-e2"
              label={t('dialog.statusComment')}
              multiline
              rows={4}
              value={data?.comment[lang] || data?.comment[data.defaultLanguage]}
            />
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={close}>{t('dialog.close')}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogFiles;
